import React from 'react';
import { Lightbulb, Mic, LayoutGrid, CalendarClock, Leaf, Smartphone } from 'lucide-react';
import { offerings } from '../mock';
import Reveal from './Reveal';

const iconMap = { Lightbulb, Mic, LayoutGrid, CalendarClock, Leaf, Smartphone };

const Offerings = () => {
  return (
    <section id="about" className="bg-[#F7F8FA] py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal variant="up">
          <div className="text-center mb-14">
            <div className="text-[#D4A853] tracking-[0.3em] text-xs font-semibold mb-3">WHAT WE OFFER</div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1430]">Complete Lighting Automation Solutions</h2>
          </div>
        </Reveal>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
          {offerings.map((o, i) => {
            const Icon = iconMap[o.icon];
            return (
              <Reveal key={o.title} variant="up" delay={i * 90}>
                <div className="lift-on-hover bg-white border border-gray-200 rounded-xl p-6 text-center h-full">
                  <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-[#D4A853]/10 flex items-center justify-center">
                    <Icon size={26} className="text-[#D4A853]" strokeWidth={1.6} />
                  </div>
                  <h3 className="text-[15px] font-semibold text-[#0B1430] mb-2 leading-tight">{o.title}</h3>
                  <p className="text-[12.5px] text-gray-500 leading-relaxed">{o.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Offerings;
